import { ACTION } from '@atlaskit/editor-common/analytics';
import { redo, undo } from '@atlaskit/editor-prosemirror/history';
import { attachInputMeta, attachInputMetaWithAnalytics } from './attach-input-meta';
import { InputSource } from './enums';
export var undoFromKeyboard = attachInputMeta(InputSource.KEYBOARD)(undo);
export var redoFromKeyboard = attachInputMeta(InputSource.KEYBOARD)(redo);
export var undoFromToolbar = attachInputMeta(InputSource.TOOLBAR)(undo);
export var redoFromToolbar = attachInputMeta(InputSource.TOOLBAR)(redo);
export var undoFromKeyboardWithAnalytics = function undoFromKeyboardWithAnalytics(editorAnalyticsAPI) {
  return attachInputMetaWithAnalytics(editorAnalyticsAPI)(InputSource.KEYBOARD, ACTION.UNDO_PERFORMED)(undo);
};
export var redoFromKeyboardWithAnalytics = function redoFromKeyboardWithAnalytics(editorAnalyticsAPI) {
  return attachInputMetaWithAnalytics(editorAnalyticsAPI)(InputSource.KEYBOARD, ACTION.REDO_PERFORMED)(redo);
};
export var undoFromToolbarWithAnalytics = function undoFromToolbarWithAnalytics(editorAnalyticsAPI) {
  return attachInputMetaWithAnalytics(editorAnalyticsAPI)(InputSource.TOOLBAR, ACTION.UNDO_PERFORMED)(undo);
};
export var redoFromToolbarWithAnalytics = function redoFromToolbarWithAnalytics(editorAnalyticsAPI) {
  return attachInputMetaWithAnalytics(editorAnalyticsAPI)(InputSource.TOOLBAR, ACTION.REDO_PERFORMED)(redo);
};